import React from 'react';

import { FontSize, FontWeight, LineHeight } from '@common/tokens';

export const Tab = ({ title, count }: { title: string; count?: number }) => (
  <div className="TabTitle">
    {count !== undefined && <div className="length">{count}</div>}
    <div className="title">{title}</div>
    <style jsx>{`
      .TabTitle {
        padding: 0 16px;
      }
      .title {
        text-align: center;
        font-weight: 900;
        text-transform: uppercase;
        min-width: 48px;
        font-style: normal;
        line-height: ${LineHeight.sm};
      }
      .length {
        text-align: center;
        font-size: ${FontSize.xxl};
        font-style: normal;
        font-weight: ${FontWeight.medium};
        line-height: ${LineHeight.xxl};
        margin-bottom: 8px;
      }
    `}</style>
  </div>
);
